export default [
  {
    path: '/tela',
    name: 'tela-inicial',
    component: () => import('@/components/servidorLogin/ServidorLogin.vue'),
  },
]
